import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom"

export default function Footer1() {
    const { t } = useTranslation();
    return (
        <>

            <footer className="footer-section">
                <div className="footer-widgets-wrapper footer-bg">
                    <div className="shape-1">
                        <img src="/assets/img/footer-shape-1.png" alt="shape-img" />
                    </div>
                    <div className="shape-2">
                        <img src="/assets/img/footer-shape-2.png" alt="shape-img" />
                    </div>
                    
                </div>
                <div className="footer-bottom">
                    <div className="container">
                        <div className="footer-wrapper d-flex align-items-center justify-content-between">
                            <p className="wow fadeInLeft color-2" data-wow-delay=".3s">
                                © All Copyright {new Date().getFullYear()} by <Link to="/">SkTech</Link>
                            </p>
                            <ul className="footer-menu wow fadeInRight" data-wow-delay=".5s">
                                <li>
                                    <Link to="/public_offer">
                                        {t("Public_Offer")}
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/privacy_policy">
                                    {t("Privacy_Policy")}
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <Link to="#header-sticky"  id="scrollUp" className="scroll-icon">
                        <i className="far fa-arrow-up" />
                    </Link>
                </div>
            </footer>

        </>
    )
}
